import type { TResponsiveFileInputArray } from '$/types/components/questions';

import * as yup from 'yup';

import { responsiveFileInputSchema } from '$/yup/schemas/responsiveFileInputSchema';

export enum FIELD_NAMES {
  CERTIFICATES_OF_ACHIEVEMENT = 'certificatesOfAchievements',
  CERTIFICATES_OF_ENROLLMENT = 'certificatesOfEnrollment',
  OTHER_DOCUMENTS = 'otherDocuments',
}

export type DocumentsSchemaType = {
  [FIELD_NAMES.CERTIFICATES_OF_ACHIEVEMENT]: TResponsiveFileInputArray;
  [FIELD_NAMES.CERTIFICATES_OF_ENROLLMENT]: TResponsiveFileInputArray;
  [FIELD_NAMES.OTHER_DOCUMENTS]?: TResponsiveFileInputArray;
};

export const documentsSchema: yup.Schema<DocumentsSchemaType> = yup.object({
  [FIELD_NAMES.CERTIFICATES_OF_ACHIEVEMENT]: responsiveFileInputSchema
    .min(1)
    .max(3)
    .required(),
  [FIELD_NAMES.CERTIFICATES_OF_ENROLLMENT]: responsiveFileInputSchema
    .min(1)
    .max(3)
    .required(),
  [FIELD_NAMES.OTHER_DOCUMENTS]: responsiveFileInputSchema.min(0).max(3),
});
